import { get as lodashGet } from 'lodash/object'
import { find as lodashFind } from 'lodash/collection'
import { GOJEK_CODE } from '../constants/pkgCode'

export const checkIsGojekDriver = (agentData) => {
  const agentTags = lodashGet(agentData, 'agent_tags', [])
  return lodashFind(agentTags, { code: GOJEK_CODE })
}

export const checkIsStaffAgent = (agentData) => {
  const agentTags = lodashGet(agentData, 'agent_tags', [])
  return lodashFind(agentTags, { tag_type: 'staff' })
}

export const checkIsLvAgent = (agentData) => {
  const agentTags = lodashGet(agentData, 'agent_tags', [])
  return !!lodashFind(agentTags, { tag_type: 'lv' })
}

export const checkIsLvAdmin = (agentData) => {
  const agentTags = lodashGet(agentData, 'agent_tags', [])
  return !!lodashFind(agentTags, { tag_type: 'lv-guardian' })
}

export const checkIsLvBlueAgent = (agentData) => {
  const agentTags = lodashGet(agentData, 'agent_tags', [])
  return !!lodashFind(agentTags, { code: 'LV_BLUE' })
}

export const checkIsLvAIAAgent = (agentData) => {
  const agentTags = lodashGet(agentData, 'agent_tags', [])
  return !!lodashFind(agentTags, { code: 'LV_AIA' })
}

export const checkIsRm = (agentData) => {
  const agentTags = lodashGet(agentData, 'agent_tags', [])
  return !!lodashFind(agentTags, { tag_type: 'internal' })
}

export const getCsDetailByAgentTag = (agentData) => {
  if (checkIsLvBlueAgent(agentData)) {
    return {
      email: 'cs.lv@ppibroker.com',
      mobile: '+62 818343494',
      wa: '62818343494',
    }
  }
  return {
    email: 'cs@ppibroker.com',
    mobile: '+62 818343494',
    wa: '62818343494',
  }
}
